<template>
  <DialogHeader>Folder info</DialogHeader>
  <DialogContent>
    <div class="w-full h-[176px] p-[9px] bg-[#FAFAFA] rounded-md mb-6">
      <ThumbnailIcon
        class="w-full h-full"
        :icon-size="140"
        type="folder"
        showShadow
      />
    </div>

    <div
      v-for="(info, index) in folderInformation"
      :key="index"
      class="w-full h-[30px] font-primary border-b border-[#E5E5E5] flex items-center justify-between text-[12px] leading-[16px] text-gray-800"
    >
      <div class="opacity-60">{{ info.label }}</div>
      <div class="font-secondary">{{ info.value }}</div>
    </div>
  </DialogContent>
</template>

<script setup lang="ts">
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import { ThumbnailIcon } from '@dacr/ui'
import type { Folder } from '@/shared/graphql/router/graphql'
import { formatTimestamp } from '@/shared/utils/datetime'
import { computed } from 'vue'

const props = defineProps<{
  folder: Folder
}>()

const folderInformation = computed(() => [
  {
    label: 'Number of files',
    value: props.folder.totalFiles,
  },
  ...(props.folder.createdAt
    ? [
        {
          label: 'Created',
          value: formatTimestamp(props.folder.createdAt),
        },
      ]
    : []),
])
</script>
